// extracted by mini-css-extract-plugin
export var container = "_dg-1";
export var cornerButtonContainer = "_dg-6";
export var disabled = "_dg-2";
export var dragActive = "_dg-3";
export var fileContainer = "_dg-5";
export var hiddenInput = "_dg-4";
export var widthContainer = "_dg-0";